import { types } from '../../../types/types';

export const reducerPesquisaSubitem = (state = {}, action = {}) => {
    
    let result = {};

    switch (action.type) {
        case types.PRODUTOS.PESQUISA_SUBITEM:
            result = action.payload;
            break;
    
        default:
            result = state;
            break;
    }

    return result;
}

export const reducerSubitemSelecionado = (state = {}, action = {}) => {
    
    let result = {};

    switch (action.type) {
        case types.PRODUTOS.SUBITEMSELECIONADO:
            result = action.payload;
            break;
    
        default:
            result = state;
            break;
    }

    return result;
}

export const reducerSubitemNovoAtualiza = (state = {}, action = {}) => {
    
    let result = {};

    switch (action.type) {
        case types.PRODUTOS.PRODNOVOATUALIZA:
            result = action.payload;
            break;
    
        default:
            result = state;
            break;
    }

    return result;
}